"use client";

import { VideoCard } from "@/components/video/video-card/video-card";
import { logEvent } from "@/service/logs/log";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import {
  createPlaylistEpisodePath,
  createPlaylistPath,
} from "@/components/video/video-card/service";

export const Icd10VideoCard = ({
  data,
  code,
}: {
  data: VideoPreviewType;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);
  const { viewModelType } = data;

  const link =
    viewModelType === "playlistEpisodePreview"
      ? createPlaylistEpisodePath(data as PlaylistEpisodePreviewVM)
      : createPlaylistPath(
          data as PlaylistPreviewVM | PlaylistTreatedAsVideoPreviewVM,
        );

  return (
    <VideoCard
      data={data}
      onClick={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: link,
          resource_type:
            viewModelType === "playlistPreview" ? "playlist" : "video",
        });
      }}
    />
  );
};
